import { createTrialBannerElement, getDocument } from '../../common/dom-helpers'
export class TrialBannerService {
  private trialBannerElement: HTMLElement | undefined

  show() {
    if (!this.trialBannerElement) {
      this.trialBannerElement = createTrialBannerElement()
    }
    const appRoot = getDocument().querySelector('goto-shell-controller')
    appRoot?.appendChild(this.trialBannerElement)
  }

  hide() {
    if (this.trialBannerElement) {
      this.trialBannerElement.remove()
    }
  }
}
